import "./chat.css";
import { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { clearAllUnreadMsgs, setRoomHasUnreadMsg } from "../../redux/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { updateStorageUnreadMessages } from "../../utilities/storageManager";

export default function ChatBody(props) {
  // the body of the chat box that holds the messages, text input field, submit button
  // props:
  //      minimized (boolean): if true, body will be hidden (display: none )
  
  let timeOutId = null;
  const dispatch = useDispatch();
  const { stayLoggedIn, isAdmin } = useSelector((state) => state.user);
  const [currentMsg, setCurrentMsg] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    setIsTyping(false);
    // when new message added to history, scroll to latest message
    const chatHistoryWindow = document.getElementById(`${props?.sessionId || "1"}`);
    chatHistoryWindow.scrollTop = chatHistoryWindow.scrollHeight;
  }, [props?.chatHistory?.length, props?.sessionId]);

  const handleSubmitMessage = (key) => {
    if (key && key !== "Enter") {
      return;
    } else {
      // enter key pressed 
      const msg = currentMsg.trim();
      if (!msg) { 
        return;
      }
      // admin will have passed in sessionId, user won't
      const adminsSessionId = props?.sessionId || null; 
      props.submitChatMsg(msg, adminsSessionId);
      setCurrentMsg("");
      if(!isAdmin){
        dispatch(clearAllUnreadMsgs());
      } else {
        dispatch(
          setRoomHasUnreadMsg({
            sessionId: props?.sessionId,
            hasNewMessage: false,
          })
          );
        }
      updateStorageUnreadMessages(
        { hasNewMessage: false, sessionId: props?.sessionId },
        stayLoggedIn
      );
    }
  };

  const handleIsTyping = () => {
    clearTimeout(timeOutId);
    if (!isTyping) {
      setIsTyping(true);
      props?.handleTyping(true, props?.sessionId);
    }
  };

  const handleStopsTyping = () => {
    clearTimeout(timeOutId);
    timeOutId = setTimeout(() => {
      setIsTyping(false);
      props?.handleTyping(false, props?.sessionId);
    }, 600);
  };

  return (
    <>
      <div className={`chat-body ${props.minimized ? "minimized" : ""}`}>
        <div>      
        {/*ERROR MSG when connetion lost */}
        {props?.chatErrorMsg && <p className="bg-danger p-3 text-light chat-err-msg">{props?.chatErrorMsg}</p>}

          <div className="chat-history" id={props?.sessionId || "1"}>
            {props?.chatHistory &&
              props?.chatHistory.length > 0 &&
              props?.chatHistory.map((message, idx) => {
                let time = new Date(message.createdAt);
                time = time.toLocaleTimeString([], {
                  hour: "numeric",
                  minute: "2-digit",
                });
                return (
                  <div key={idx} className="mb-3">
                    {message?.user && (
                      <>
                        <p
                          className={
                            props?.isAdmin
                              ? "bg-primary p-3 ms-4 mb-0 text-light rounded"
                              : "p-3 me-4 mb-0 text-dark rounded"
                          }
                          style={
                            !props?.isAdmin ? { backgroundColor: "white" } : {}
                          }
                        >
                          {message.user}
                        </p>
                        {message?.createdAt && (
                          <div
                            className={props?.isAdmin ? "ms-4 mb-0" : ""}
                            style={{
                              color: "gray",
                              fontSize: "0.7rem",
                              fontStyle: "italic",
                            }}
                          >
                            <b>{!props?.isAdmin ? "You" : "User"} </b>
                            {time}
                          </div>
                        )}
                      </>
                    )}
                    {message?.admin && (
                      <>
                        <p
                          className={
                            !props?.isAdmin
                              ? "bg-primary p-3 ms-4 mb-0 text-light rounded"
                              : "p-3 me-4 mb-0 text-dark rounded"
                          }
                          style={
                            props?.isAdmin ? { backgroundColor: "white" } : {}
                          }
                        >
                          {message.admin}
                        </p>
                        {message?.createdAt && (
                          <div
                            className={!props?.isAdmin ? "ms-4 mb-0" : ""}
                            style={{
                              color: "gray",
                              fontSize: "0.7rem",
                              fontStyle: "italic",
                            }}
                          >
                            {" "}
                            <b>{props?.isAdmin ? "You" : "Admin"} </b>
                            {time}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
          </div>
          {!props?.showRestartChat && (
            <textarea
              onKeyUp={(event) => {
                handleSubmitMessage(event.key);
                handleStopsTyping();
              }}
              id="client-msg"
              className="form-control mb-0"
              placeholder="Your Message"
              value={currentMsg}
              onChange={(event) => {
                setCurrentMsg(event.target.value);
                handleIsTyping();
              }}
            ></textarea>
          )}
        </div>
        {!props?.showRestartChat && (
          <div
            style={{
              fontSize: "small",
              fontStyle: "italic",
              minHeight: "20px",
            }}
          >
            {props?.partnerIsTyping && (
              <>
                <span className="dots-container">
                  {" "}
                  <span className="dot dot-1"></span>{" "}
                  <span className="dot dot-2"></span>{" "}
                  <span className="dot dot-3"></span>{" "}
                </span>{" "}
                <span style={{ marginLeft: "2px" }}>typing</span>
              </>
            )}
          </div>
        )}

        <div
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {props?.isAdmin && (
            <Button
              onClick={() => props?.handleEndChat(props?.sessionId)}
              className="btn btn-light btn-block mt-3"
            >
              End Chat
            </Button>
          )}
          {props?.showRestartChat && (
            <Button
              onClick={props?.handleStartNewChat}
              variant="success"
            >
              Start New Chat
            </Button>
          )}
        </div>
      </div>
    </>
  );
}